import styled from 'styled-components';
import { pxToRem, media, fontWeight } from '$util/theme';
import Section from '$components/layout/Section';

export default styled(Section)`
  h2 {
    font-size: ${pxToRem(26)};
    line-height: ${pxToRem(32)};
    color: #020202;
    ${media.up('md')} {
      font-size: ${pxToRem(42)};
      font-weight: ${fontWeight.semiLight};
      line-height: ${pxToRem(48)};
    }
  }
  h3 {
    color: #020202;
  }
  ul > li,
  p {
    font-size: ${pxToRem(15)};
    line-height: 1.75;
    color: #818182;
    ${media.up('md')} {
      font-size: ${pxToRem(20)};
    }
    &.italic {
      font-style: italic;
    }
  }
  .content {
    &:first-child,
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      margin-bottom: 40px;
    }
    .formula {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-style: italic;
      font-size: ${pxToRem(13)};
      ${media.up('md')} {
        font-size: ${pxToRem(18)};
      }
      padding-top: 10px;
      width: fit-content;
      > span:first-child {
        border-bottom: 1px solid #818182;
      }
    }
  }
`;
